import React from 'react'
import Props, { Data } from '../interfaces/ICardAccess'
import loguito from '../../static/loguito.svg'
import '../sass/cardAccess.sass'
import { Link } from 'react-router-dom'

const CardAccess = ({ data, children }: Props): JSX.Element => {

    const { title, name, info, }: Data = data

    return (
        <div className="containerAccess">
            <Link to='/' style={{ width: 'max-content' }}>
                <img src={loguito} alt="logEntity" />
            </Link>
            <div className="contAccess">
                <div className="titleAccess">
                    <div>{title}</div>
                    {
                        name && <div>{name}</div>
                    }
                </div>
                {
                    info &&
                    <div className="infoAccess">
                        <div className="infTit">{info}</div>
                        <div className="infHelp">
                            <span>¿Necesitas ayuda?</span>
                        </div>
                    </div>
                }
                {
                    children
                }
            </div>
        </div>
    )
}

export default CardAccess
